import stickybits from 'stickybits';

export default (function () {
    stickybits('.site-header__floatnav', { useStickyClasses: true });
})();